import React from 'react';
import { Link } from 'react-router-dom';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer';
import ContactForm from './ContactForm';

const bgimg1 = require('./../../images/banner/bnr1.jpg');
const bgimg2 = require('./../../images/background/bg5.jpg');

const Contact = () => {


	return (
		<>
			<Header />
			<div className="page-content bg-white">
				<div className="dlab-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + bgimg1 + ")" }}>
					<div className="container">
						<div className="dlab-bnr-inr-entry">
							<h1 className="text-white">Contact</h1>
							<div className="breadcrumb-row">
								<ul className="list-inline">
									<li><Link to={'./'}><i className="fa fa-home"></i></Link></li>
									<li>Contact</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="content-block">
					<div className="section-full content-inner-2 contact-form bg-white" style={{ backgroundImage: "url(" + bgimg2 + ")", backgroundSize: "100%" }}>
						<div className="container">
							<div className="row">
								<div className="col-xl-4 col-lg-6 col-md-6 d-flex m-md-b30 m-lg-b30">
									<div className="p-a30 border contact-area border-1 align-self-stretch radius-sm bg-white">
										<h3 className="m-b5">Quick Contact</h3>
										<p>If you have any questions simply use the following contact details.</p>
										<ul className="no-margin">
											<li className="icon-bx-wraper left m-b30">
												<a href='https://maps.app.goo.gl/PsWLFsJPuy3rSRWK7'><div className="icon-bx-xs border-1 text-primary"> <span className="icon-cell"><i className="ti-location-pin"></i></span> </div>
													<div className="icon-content">
														<h6 className="text-uppercase m-tb0 dlab-tilte">Address:</h6>
														<p>2/70, Chelli Amman Kovil St, Puthur, ESIC Nagar, Tiruvancheri, Chennai, Tamil Nadu 600126</p>
													</div></a>
											</li>
											<li className="icon-bx-wraper left  m-b30">
												<a href='mailto:cacofachocolates@gmail.com'><div className="icon-bx-xs border-1 text-primary"> <span className="icon-cell"><i className="ti-email"></i></span> </div>
													<div className="icon-content">
														<h6 className="text-uppercase m-tb0 dlab-tilte">Email:</h6>
														<p>cacofachocolates@gmail.com</p>
													</div></a>
											</li>
											<li className="icon-bx-wraper left">
												<a href='tel:+917358605115'><div className="icon-bx-xs border-1 text-primary"><span className="icon-cell"><i className="ti-mobile"></i></span> </div>
													<div className="icon-content">
														<h6 className="text-uppercase m-tb0 dlab-tilte">PHONE</h6>
														<p>+91 7358605115</p>
													</div></a>
											</li>
											<li className="icon-bx-wraper left">
												<a href='https://www.instagram.com/cacofa_chocolates/' target='blank'><div className="icon-bx-xs border-1 text-primary"><span className="icon-cell"><i class="fa fa-instagram" aria-hidden="true"></i></span> </div>
													<div className="icon-content">
														<h6 className="text-uppercase m-tb0 dlab-tilte">cacofa_chocolates</h6>
													</div></a>
											</li>
											
											
										</ul>

									</div>
									
								</div>
								<ContactForm/>
								<div className="col-xl-4 col-lg-12 d-flex">
									<iframe
										src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3889.2238860061966!2d80.14145797871247!3d12.893320400719482!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525953afade851%3A0x6a4fe2519dfd8184!2sCacofa%20homemade%20chocolate%20%26%20cakes!5e0!3m2!1sen!2sin!4v1717404678253!5m2!1sen!2sin"
										width="600"
										height="450"
										style={{ border: 0 }}
										allowFullScreen=""
										loading="lazy"
										referrerPolicy="no-referrer-when-downgrade"></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default Contact;
